module.exports = __webpack_public_path__ + "static/media/Nasu-Bold.d6ae17b3.ttf";